import React, { useCallback, useState } from "react";
import { Page, Card, Tabs } from "@shopify/polaris";

import SalsifyConfig from "./components/Salsify/SalsifyConfig";
import store from "store-js";

function Salsify() {

  const currentTab = store.get("salsifyTab") || 0;
  const [selected, setSelected] = useState(currentTab);

  store.set("salsifyTab", selected);

  const handleTabChange = useCallback((index) => setSelected(index), []);

  const tabs = [
    {
      id: "salsifyConfig",
      title: "Salsify",
      content: "Choose metafields to monitor",
      page: <SalsifyConfig />,
      panelID: "salsifyConfigPanel",
    },
  ];

  return (
    <Page breadcrumbs={[{ url: "/" }]} title={tabs[selected].title} fullWidth>
      <Card>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
          {tabs[selected].page}
        </Tabs>
      </Card>
    </Page>
  );
}

export default Salsify;
